// extracted by mini-css-extract-plugin
export default {"section":"DynamicSection_section__V1xBj"};